import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function HeroCard(props) {
  const { imgUrl, title, author, url, label, time } = props;

  return (
    <Root href={url} target="_blank" rel="noreferrer">
      <Wrapper img={imgUrl}>
        <NewsLabel>{label}</NewsLabel>
        <LeftBottomWrapper>
          <Title>{title}</Title>
          <Info>
            <Author>
              <img src={require('assets/images/icons/carbon_user-avatar.png')} alt="author" />
              <h6>{author}</h6>
            </Author>
            <Time>
              <img src={require('assets/images/icons/carbon_time.png')} alt="Time" />
              <h6>{time}</h6>
            </Time>
          </Info>
        </LeftBottomWrapper>
      </Wrapper>
    </Root>
  )
}

HeroCard.propTypes = {
  label: PropTypes.string,
  imgUrl: PropTypes.any,
  title: PropTypes.string,
  author: PropTypes.string,
  url: PropTypes.string
}

const Root = styled.a`
  display: contents;

  &:hover {
    h2, h6 {
      color: #3398DC;
    }
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${props => `url(${props.img})`};
  background-size: cover;
  background-position: center;
  position: relative;
  transition: all 0.3s;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.55));
  }
`;

const NewsLabel = styled.span`
  position: absolute;
  background: #3398DC;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: #FFFFFF;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;

  ${vw('font-size', 8, 12)}
  ${vw('line-height', 14, 22)}
  ${vw('top', 8, 15)}
  ${vw('left', 8, 15)}
  ${vw('padding-left', 8, 15)}
  ${vw('padding-right', 8, 15)}
`;

const LeftBottomWrapper = styled.div`
  position: absolute;

  ${vw('left', 8, 15)}
  ${vw('bottom', 8, 15)}
  ${vw('margin-right', 8, 15)}
`;

const Title = styled.h2`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  color: #FFFFFF;
  transition: all 0.25s;

  ${vw('font-size', 12, 18, 24)}
  ${vw('line-height', 16, 28, 35)}
`;

const Info = styled.div`
  display: flex;

  ${vw('margin-top', 4, 10)}
`;

const Author = styled.div`
  display: flex;
  ${vw('margin-right', 10, 15)}

  > img {
    ${vw('width', 16)}
    ${vw('height', 16)}
  }
  
  > h6 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    color: #FFFFFF;
    transition: all 0.25s;

    ${vw('font-size', 10, 12)}
    ${vw('line-height', 18, 17)}
    ${vw('margin-left', 5)}
  }
`;

const Time = styled.div`
  display: flex;

  > img {
    ${vw('width', 16)}
    ${vw('height', 16)}
  }
  
  > h6 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    color: #FFFFFF;
    transition: all 0.25s;

    ${vw('font-size', 10, 12)}
    ${vw('line-height', 18, 17)}
    ${vw('margin-left', 5)}
  }
`;

export default HeroCard
